module.exports = __webpack_public_path__ + "d08afeeb2bef8f9aaea324fc4591a5de.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BY.svg
// module id = mZm+
// module chunks = 0